<template>
  <nav>
    <ul class="flex flex-auto items-center gap-1">
      <template v-for="(item, index) in items" :key="index">
        <li v-if="item.group">
          <app-dropdown-menu
            :key="item.title"
            v-slot="{ open }"
            class="group flex items-center gap-2"
            :class="[
              navigationItemClass,
              { [navigationItemActiveClass]: item.selected },
            ]"
            item-class="!font-normal mb-1 last:mb-0"
            :items="item.items"
          >
            {{ item.title }}
            <app-icon
              class="transition"
              :class="{ 'rotate-180': open }"
              icon="ph:caret-down"
              :size="16"
            />
          </app-dropdown-menu>
        </li>

        <li v-if="!item.divider && !item.group">
          <nuxt-link
            :active-class="navigationItemActiveClass"
            :class="navigationItemClass"
            :to="item.to"
          >
            {{ item.label }}
          </nuxt-link>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import type { DropdownMenuItemDefinition } from "@pollen/ui-library";

const properties = defineProps<{
  items: DropdownMenuItemDefinition[];
  transparent?: boolean;
}>();

const navigationItemClass = computed(() => {
  return `block rounded p-2 transition ${properties.transparent ? "hover:bg-primary-100 hover:text-primary-950" : "hover:bg-primary-50 hover:text-primary-950"}`;
});
const navigationItemActiveClass =
  "font-semibold bg-primary-100 font-semibold text-primary-950";
</script>
